import React from 'react';
import _ from 'lodash';
import {observer} from 'mobx-react';
import {Modal} from 'shared/components/modals';
import PolicySummaryModalContent from './PolicySummaryModalContent';

const PolicySummaryModal = observer(({uiState}) => {
  const {policySummaryAccount, policy, employee} = uiState;
  if (!_.get(policySummaryAccount, 'timeOffType')) return null;

  return (
    <Modal isOpen={uiState.policySummaryModalOpen} onHide={() => uiState.closePolicySummaryModals()} size='md'>
      <PolicySummaryModalContent
        timeOffTypeId={_.get(policySummaryAccount, 'timeOffType.id')}
        policy={policy}
        employee={employee}
        policySummaryAccount={policySummaryAccount}
      />
    </Modal>
  );
});

export default PolicySummaryModal;
